<template>
  <section class="py-16 md:py-24">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <h2 v-if="title" class="text-center text-3xl font-bold text-gray-900 dark:text-white md:text-4xl">
        {{ title }}
      </h2>
      <div class="mx-auto mt-12 grid max-w-5xl gap-8 sm:grid-cols-2 lg:grid-cols-3">
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="flex flex-col rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition hover:border-primary-500/30 hover:shadow-md dark:border-gray-700 dark:bg-gray-800/50 dark:hover:border-primary-400/30"
        >
          <div
            v-if="feature.icon"
            class="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500/10 text-primary-600 dark:bg-primary-400/10 dark:text-primary-400"
          >
            <UIcon :name="feature.icon" class="size-6" />
          </div>
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{ feature.title }}
          </h3>
          <p class="mt-2 flex-1 text-gray-600 dark:text-gray-300">
            {{ feature.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
  features: Array<{
    icon?: string
    title: string
    description: string
  }>
}>()
</script>
